export default __webpack_public_path__ + "static/testi-1-288a6007684f97fb44ec3309466dcc70.png";